import { createSettingsListApi } from './settings-list-api.factory';

export const recordStagesApi = createSettingsListApi('/record-stages');
